import { SdkThunkActionResult } from "@payping/redux/reducers";

import { SET_DASHBOARD_PREFERENCE, SetDashboardPreferenceAction } from "../reducers/dashboardPreference";

export function setDashboardPreference(
  preference: SetDashboardPreferenceAction["payload"],
): SdkThunkActionResult<Promise<void>> {
  return async (dispatch): Promise<void> => {
    dispatch({ payload: preference, type: SET_DASHBOARD_PREFERENCE });
  };
}
